import React from "react";
import { Box, Button } from "@mui/material";
import {
  SidebarNavGroup,
  SidebarNavItem,
  SidebarNavPanel,
  SidebarNavScrollArea,
  SidebarNavSection,
  SidebarNavSectionHeader,
} from "../../common/sidebarNav";
import { getVisibleNavSections } from "./navSectionUtils";

export const AGENT_CONFIG_NAV_WIDTH = 220;

export default function AgentConfigNav({
  navGroups,
  activeTab,
  activeSection,
  setActiveTab,
  onNavigateToSection,
  isSystemAgent,
  isCreateMode,
  agentId,
  saving,
  showChangeSetupMode,
  onChangeSetupMode,
}) {
  return (
    <SidebarNavPanel sx={{ width: AGENT_CONFIG_NAV_WIDTH }}>
      {showChangeSetupMode && (
        <Box sx={{ flexShrink: 0, px: 1, pt: 1, pb: 0.5 }}>
          <Button
            size="small"
            variant="text"
            disabled={saving}
            onClick={onChangeSetupMode}
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              fontSize: 12,
              color: "text.secondary",
              px: 1,
              minHeight: 28,
              borderRadius: "8px",
              "&:hover": { backgroundColor: "action.hover" },
            }}
          >
            Change setup mode
          </Button>
        </Box>
      )}

      <SidebarNavScrollArea>
        {navGroups.map((group, groupIndex) => {
          const visibleTabs = group.tabs.filter((tab) => {
            if (isSystemAgent && !tab.systemAgentVisible) return false;
            return true;
          });
          if (visibleTabs.length === 0) return null;

          return (
            <SidebarNavGroup
              key={group.label}
              sx={{ mt: groupIndex === 0 && !showChangeSetupMode ? 0 : "14px" }}
            >
              <SidebarNavSectionHeader>{group.label}</SidebarNavSectionHeader>
              <SidebarNavSection>
                {visibleTabs.map((tab) => {
                  const visibleSections = getVisibleNavSections(tab, {
                    isSystemAgent,
                    isCreateMode,
                    agentId,
                  });
                  const showParentNav =
                    !tab.sectionNavOnly || visibleSections.length === 0;
                  const TabIcon = tab.icon;

                  return (
                    <Box key={tab.id}>
                      {showParentNav && (
                        <SidebarNavItem
                          item={{
                            label: tab.label,
                            icon: <TabIcon />,
                          }}
                          selected={activeTab === tab.id && !activeSection}
                          onClick={() => setActiveTab(tab.id)}
                        />
                      )}
                      {visibleSections.map((section) => (
                        <SidebarNavItem
                          key={`${tab.id}-${section.id}`}
                          nested
                          danger={section.danger}
                          item={{ label: section.label }}
                          selected={
                            activeTab === tab.id &&
                            activeSection === section.id
                          }
                          onClick={() =>
                            onNavigateToSection(tab.id, section.id)
                          }
                        />
                      ))}
                    </Box>
                  );
                })}
              </SidebarNavSection>
            </SidebarNavGroup>
          );
        })}
      </SidebarNavScrollArea>
    </SidebarNavPanel>
  );
}
